import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { AssessmentProvider } from '../../AssessmentContext';
import { AssessmentReviewContextProvider } from './AssessmentReviewContext';
import QuestionDetail from './QuestionDetail';
import AssessmentReviewDetail from './AssessmentReviewDetail';

function AssessmentReviewDetailRouter(props) {
  const { assessment } = props;
  const match = useRouteMatch();

  // TODO: return a loading state
  if (!assessment) {
    return null;
  }

  return (
    <AssessmentProvider assessment={assessment}>
      <AssessmentReviewContextProvider assessment={assessment}>
        <Switch>
          <Route
            path={`${match.path}/questions/:questionId`}
            render={(routeProps) => (
              <QuestionDetail {...props} {...routeProps} />
            )}
          />
          <Route
            path={`${match.path}/review`}
            render={(routeProps) => (
              <AssessmentReviewDetail {...props} {...routeProps} />
            )}
          />
          {/* <Route
          path={`${match.path}`}
          render={(routeProps) => <AssessmentReview {...props} {...routeProps} />}
        /> */}
        </Switch>
      </AssessmentReviewContextProvider>
    </AssessmentProvider>
  );
}

export default AssessmentReviewDetailRouter;
